import React from 'react';
import { BODY_SIDEBAR_SHOWN_CLASS } from '../../../constants';
import './style.scss';

/**
 * "Closes" the sidebar by removing the appropriate class from the <body> element.
 */
const closeSidebar = () => {
    document.body.classList.remove(BODY_SIDEBAR_SHOWN_CLASS);
};

const Overlay = () => <div className="sidebar-overlay" onClick={closeSidebar} />;

export default Overlay;
